import { useWatch } from '../../../contexts';
import { useContentFieldPath } from '../fieldPaths/useContentFieldPath';

export const useContentWatch = () => useWatch({ name: useContentFieldPath() });
